module.exports = __webpack_public_path__ + "static/images/home-pfe.ee5fa714ceadac7c1966c9c5f312a574.svg";